module.exports = __webpack_public_path__ + "/content/shared/img/lambo/landing/Lambo.Config.Resources.LandingImages.LamborghiniLandingPage3.png";